import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CONSTANTS } from "../../config";
import { LocalService } from "../../core";

@Component({
  selector: "app-account-details",
  templateUrl: "./account-details.component.html",
  styleUrls: ["./account-details.component.scss"],
})
export class AccountDetailsComponent implements OnInit {
  tabs: any[] = [];
  selectedTab: string = "activity";
  isPracticeLead: boolean = false;
  isAdminUser: boolean = false;
  userProfile: any;
  adminUser = CONSTANTS.admin;
  practiceLeadUser = CONSTANTS.practiceLead;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.userProfile = LocalService.get("userProfile");
    this.checkRoles();
    this.buildTabs();
    this.subscribeToQueryParams();
  }

  private buildTabs(): void {
    const hasRequiredRole = this.isPracticeLead || this.isAdminUser;
    this.tabs = [
      {
        id: "activity",
        label: this.translate.instant("accountDetails.activity"),
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard-list h-4 w-4"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><path d="M12 11h4"></path><path d="M12 16h4"></path><path d="M8 11h.01"></path><path d="M8 16h.01"></path></svg>'
      },
      {
        id: "participation",
        label: this.translate.instant("accountDetails.participation"),
        isVisible: hasRequiredRole,
        iconHtml:`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-handshake h-4 w-4"><path d="m11 17 2 2a1 1 0 1 0 3-3"></path><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path><path d="m21 3 1 11h-2"></path><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path><path d="M3 4h8"></path></svg>`
      },
      {
        id: "rewards",
        label: this.translate.instant("accountDetails.rewards"),
        isVisible: hasRequiredRole,
        iconHtml:`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gift h-4 w-4"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path></svg>`
      }
    ];
  }

  private subscribeToQueryParams(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (params.tab === "participation" && (this.isPracticeLead || this.isAdminUser)) {
        this.selectedTab = "participation";
      } else if (params.tab === "cashPayment") {
        this.selectedTab = "activity";
      }
    });
  }

  onTabChange(id: string): void {
    this.selectedTab = id;
  }

  checkRoles(): void {
    this.isAdminUser = this.userProfile.hasOwnProperty("userType")
      ? true
      : this.userProfile.roles.filter((item: any) =>
          this.adminUser.includes(item.name)
        ).length;
    this.isPracticeLead = this.userProfile.hasOwnProperty("userType")
      ? true
      : this.userProfile.roles.find(
          (item: any) => item.name === this.practiceLeadUser
        );
  }
}
